"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataTable = DataTable;
require("antd/lib/table/style");
var _table = _interopRequireDefault(require("antd/lib/table"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
require("./DataTable.less");
var _excluded = ["className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var PaginationItemsRender = function PaginationItemsRender(_ref) {
  var type = _ref.type,
    originalElement = _ref.originalElement;
  if (type === 'prev') {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "text-green1-60 mr-[24px]"
    }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      size: 14,
      viewBox: "0 0 8 16",
      type: "caret-left-heavy-16",
      className: "mr-[10px] text-green1-60 relative top-[2px]"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "text-green1-60"
    }, "Previous"));
  }
  if (type === 'next') {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "text-green1-60 ml-[24px]"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-green1-60"
    }, "Next"), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      size: 14,
      type: "caret-right-heavy-16",
      viewBox: "0 0 8 16",
      className: "ml-[10px] text-green1-60 relative top-[2px]"
    }));
  }
  return originalElement;
};
function DataTable(_ref2) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded);
  var pagination = props.pagination ? _objectSpread({
    pageSize: 100,
    pageSizeOptions: ['10', '20', '50', '100'],
    total: props.dataSource && props.dataSource.length,
    className: 'text-green1-60 font-[16px] leading-[20px] relative',
    itemRender: function itemRender(_, type, originalElement) {
      return /*#__PURE__*/_react.default.createElement(PaginationItemsRender, {
        type: type,
        originalElement: originalElement
      });
    },
    showTotal: function showTotal(total, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        start = _ref4[0],
        end = _ref4[1];
      return "".concat(start, "-").concat(end, " of ").concat(total, " items");
    }
  }, props.pagination) : props.pagination;
  // DataTable doesn't assume rows link somewhere by default so .pointer isn't applied universally.
  // However legacy Table component did assume this, so we use the existence of props.onRow as a
  // proxy for whether the row should show a pointer cursor on hover.
  var rowClassName = (0, _classnames.default)({
    'cursor-pointer': !!props.onRow
  }, props.rowClassName);
  return /*#__PURE__*/_react.default.createElement(_table.default, _extends({
    locale: {
      emptyText: props.emptyText || 'No data to display'
    },
    className: (0, _classnames.default)('data-table', className),
    rowClassName: rowClassName
  }, props, {
    pagination: pagination,
    scroll: props.scroll
  }));
}